

// Search users based on normal segmentation with the addition of groups
// Add additional search bar designated for matching groups


const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the content liked by component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('userGroupsSearch', ['Application', 'Assessments', 'Authorization', 'AdminUsers', 'Users', 'Categories', 'Groups', '$q', '$translate', function (Application, Assessments, Authorization, AdminUsers, Users, Categories, Groups, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      onQuery: '&',
      onAdd: '&?',
      onRemove: '&?',
      onAllRemoved: '&?',
      placeholder: '=',
      initialValues: '=?',
      userRestrictions: '=',
      explore: '@',
      unrestrictedSearch: '@',
      suspended: '@',
      filterType: '@?',
      for: '@?',
      managerQuery: '=?',
      prioritizeCreator: '@?',
      allowUser: '@?',
      textDisallowed: '@?',
      suspendedOption: '@?',
      includeAssessments: '@?'
    },
    template: require('../../../templates/directives/groups/user-groups-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.placeholder = '';
      self.allowFilters = $scope.filterType && $scope.filterType === 'none' ? false : true;
      self.filtersVisible = false;
      self.flags = Application.features.flags();
      self.showGroups = false;
      self.translations = {};

      var processPlaceholder = function(){
        if($scope.placeholder && $scope.placeholder.length) {
          self.placeholder = $scope.placeholder;
          return;
        }
        if (self.flags.groups) {
          if ($scope.includeAssessments) {
            self.placeholder = 'modules.usersearch.placeholderWithGroupAndAssessment';
            return;
          }
          self.placeholder = 'modules.usersearch.placeholderWithGroup';
          return;
        }
        if ($scope.includeAssessments) {
          self.placeholder = 'modules.usersearch.placeholderWithAssessment';
          return;
        }
        self.placeholder = 'modules.usersearch.placeholder';
      };
      processPlaceholder();

      self.options = {
        querySpecs: {
          group_match: false,
          teams_match: false,
          user_groups: false
        },
        activeStatus: [
          {
            type: 'activeStatus',
            name: 'Active',
            value: 'false',
            _id: 'active'
          },
          {
            type: 'activeStatus',
            name: 'Suspended',
            value: 'true',
            _id: 'suspended'
          },
          {
            type: 'activeStatus',
            name: 'All',
            value: '$in,2,true,false',
            _id: 'all'
          }
        ],
        roles: [
          {
            type: 'role',
            name: 'Admins',
            text: 'Admins',
            value: 'admin',
            _id: 'admin-role'
          }, {
            type: 'role',
            name: 'Creators',
            text: 'Creators',
            value: 'creator',
            _id: 'creator-role'
          }, {
            type: 'role',
            name: 'Users',
            text: 'Users',
            value: 'user',
            _id: 'user-role'
          },
          {
            type: 'role',
            name: 'External Users',
            text: 'External Users',
            value: 'external',
            _id: 'external-role'
          }
        ].filter(function (role_option) {
          if(!$scope.userRestrictions) {
            return role_option;
          }
          if(!$scope.userRestrictions.role) {
            return role_option;
          }
          return role_option.value === $scope.userRestrictions.role;
        }),
        dateAgo: function(days) {
          return 'date-' + moment().subtract(days, 'days').format('MM-DD-YY');
        },
        makeLabel: function(type, value) {
          if (type === 'department' || type === 'location' || type === 'team' || type === 'org_level' || type === 'grade' || type === 'text' || type === 'role') {
            return value;
          }
          if (type === 'hired') {
            return self.translations['edit.assessment.hired_within'] + ' ' + value + ' ' + self.translations['edit.assessment.days'];
          }
          if (type === 'created') {
            return self.translations['edit.assessment.created_less'] + ' ' + value + ' ' + self.translations['edit.assessment.days_ago'];
          }
          if (type === 'active') {
            if (value === 1) {
              return self.translations['edit.assessment.active_today'];
            }
            return self.translations['edit.assessment.active_within'] + ' ' + value + ' ' + self.translations['edit.assessment.days_ago'];
          }
        }
      };

      self.settings = {
        loading: false,
        placeholders: {
          users: {name: 'Users', text: 'Users', _id: 'users', placeholder: true},
          skills: {name: 'Skills', text: 'Skills', _id: 'skills', placeholder: true},
          location: {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true},
          department: {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true},
          team: {name: 'Teams', text: 'Teams', _id: 'teams', placeholder: true},
          org_level: {name: 'OrgLevels', text: 'OrgLevels', _id: 'org_levels', placeholder: true},
          grade: {name: 'Grades', text: 'Grades', _id: 'grades', placeholder: true},
          category: {name: 'Categories', text: 'Categories', _id: 'categories', placeholder: true},
          groups: {name: 'Groups', text: 'Groups', _id: 'groups', placeholder: true},
          assessments: {name: 'Assessments', text: 'Assessments', _id: 'assessments', placeholder: true}
        },
        legacyName: function(item) {
          var parentName;
          var papaName;

          item.text = item.name;

          if (item.parent && item.parent.name) {
            parentName = item.parent.name + ' -> ';
            item.text = parentName + item.text;
          }

          if (item.parent && item.parent.parent && item.parent.parent.name) {
            papaName = item.parent.parent.name + ' -> ';
            item.text = papaName + item.text;
          }
        },
        typeMap: function() {
          return {
            location: [],
            department: [],
            team: [],
            grade: [],
            org_level: [],
            group: [],
            user: [],
            assessment: []
          };
        },
        removeUnique: function(type) {
          for (var i = 0; i < self.standard.queries.length; i++) {
            if (self.standard.queries[i].type === type) {
              var removed = self.standard.queries.splice(i, 1);
              return;
            }
          }
        },
        outsideAdd: function(type, value) {
          var item;
          if (type === 'role' || type === 'activeStatus') {
            self.settings.removeUnique(type);
            item = value;
          } else if (type === 'hired' || type === 'created' || type === 'active') {
            self.settings.removeUnique(type);
            item = {
              name: self.options.makeLabel(type, value),
              text: value,
              _id: value + type,
              type: type
            };
          } else {
            item = value
          }
          self.standard.queries.push(item);
          self.standard.buildQuery();
        }
      };
      var initialWatch = $scope.$watch('initialValues', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        newVal.forEach(function (value) {
          if (!value.name) {
            throw Error('Initial values must have name specified');
          }
          self.settings.outsideAdd(null, value);
        });
        initialWatch();
      });
      // 1. Search users
      // 2. Match names and segmentation fields
      // 3. Match groups based on segmentation fields

      self.users = {
        get: function(input) {
          var query = {
            page: 1,
            per_page: 6,
            full_name: '$regex,2,' + input + ',i',
            sort: 'full_name,-1',
            fields: '_id,first_name,last_name,full_name,email,image,linked_location,linked_departments,job_title,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,groups'
          };

          if ($scope.suspended) {
            query.suspended = true;
          }

          if ($scope.userRestrictions) {
            for (var key in $scope.userRestrictions) {
              query[key] = $scope.userRestrictions[key];
            }
          }

          if ($scope.managerQuery) {
            query.manager_query = true;
          }

          if (!$scope.managerQuery && $scope.prioritizeCreator) {
            query.prioritize_creator = true;
          }

          // Start to use unrestrictedSearch in place of allowUser
          if ($scope.allowUser || $scope.unrestrictedSearch) {
            query.fields = 'first_name,last_name,email,full_name,role,image,last_login,manager_email,skills';
            return Users.find(query).$promise;
          }
          return AdminUsers.find(query).$promise;
        },
        parse: function(data) {
          var options = [];
          if (!data.length) {
            return [];
          }

          options.push(self.settings.placeholders.users);

          data.forEach(function(item) {
            options.push(Object.assign({}, item, {
              name: item.full_name,
              text: item.full_name,
              type: 'user',
              _id: item._id
            }));
          });

          return options;
        }
      }

      self.categories = {
        get: function(input) {
          // ** TODO ** Implement selections to prevent showing in search
          var query = {
            term: input,
            types: 'locations,departments,teams,org_levels,grades',
            // ignoreSelections: $scope.showDecendants ? true : false,
          };

          // if ($scope.selections && $scope.selections.length) {
          //   query.selections = $scope.selections.join(',');
          // }

          return Categories.search(query).$promise
        },
        parse: function(data) {
          var options = [];
          var matches = {
            location: [],
            department: [],
            team: [],
            org_level: [],
            grade: [],
            category: []
          };

          data.forEach(function(item) {
            var itemType = item.location ? 'location' : item.department ? 'department' : item.team ? 'team' : item.org_level ? 'org_level' : item.grade ? 'grade' : item.category ? 'category' : '';

            if (!itemType || !matches[itemType]) {
              return;
            }

            // Add legacy name
            self.settings.legacyName(item);
            item.type = itemType;

            // Add item to matches type
            matches[itemType].push(item);
          });

          // Add requisite placeholder
          for (var key in matches) {
            if (matches[key].length) {
              options.push(self.settings.placeholders[key]);
              options = options.concat(matches[key]);
            }
          }

          return options;
        }
      };

      self.groups = {
        get: function(input) {
          // ** TODO ** Implement selections to prevent showing in search
          var query = {
            name: '$regex,2,' + input + ',i',
            // _id: '$nin,' + $scope.selections.length + ',' + $scope.selections.join(','),
            page: 1,
            per_page: 40
          };

          return Groups.find(query).$promise;
        },
        parse: function(data) {
          var options = [];
          if (!data.length) {
            return [];
          }

          options.push(self.settings.placeholders.groups);

          data.forEach(function(item) {
            item.text = item.name;
            item.type = 'group';
            options.push(item);
          });

          return options;
        }
      };

      self.assessments = {
        get: function(input) {
          var query = {
            title: '$regex,2,' + input + ',i',
            page: 1,
            per_page: 40
          };

          return Assessments.find(query).$promise;
        },
        parse: function(data) {
          var options = [];
          if (!data.length) {
            return [];
          }

          options.push(self.settings.placeholders.assessments);

          data.forEach(function(item) {
            options.push(Object.assign({}, item, {
              name: item.title,
              text: item.title,
              type: 'assessment',
              _id: item._id
            }));
          });

          return options;
        }
      }

      self.standard = {
        queries: [],
        activeQuery: {},
        getOptions: function(input) {
          var deferred = $q.defer();

          var options = [];

          var queries = [Promise.resolve(), Promise.resolve()];
          if (!$scope.for || $scope.for === 'users' || $scope.for === 'all') {
            queries[0] = self.users.get(input);
          }
          if (!$scope.for || $scope.for === 'categories' || $scope.for === 'all') {
            queries[1] = self.categories.get(input);
          }
          if (self.flags.groups) {
            queries.push(self.groups.get(input));
          }
          if ($scope.includeAssessments) {
            queries.push(self.assessments.get(input));
          }

          $q.all(queries)
          .then(function(results) {
            var users = results[0];
            var categories = results[1];
            var groups;
            var assessments;

            if (self.flags.groups) {
              groups = results[2];
              assessments = results[3] || [];
            } else {
              assessments = results[2] || [];
            }

            if (users && users.length) {
              options = options.concat(self.users.parse(users));
            }
            if (categories && categories.length) {
              options = options.concat(self.categories.parse(categories));
            }
            if (groups && groups.length) {
              options = options.concat(self.groups.parse(groups));
            }
            if (assessments && assessments.length) {
              options = options.concat(self.assessments.parse(assessments));
            }

            deferred.resolve(options);
          }).catch(function(error) {
            console.log('Error in getStandardOptions: ', error);
            deferred.reject();
          });

          return deferred.promise;
        },
        tagAdded: function($tag) {
          self.standard.buildQuery();
          if ($scope.onAdd) {
            $scope.onAdd({item: $tag});
          }
        },
        tagAdding: function($tag) {
          if (!$tag.type) {
            if ($scope.textDisallowed) {
              return false;
            }

            $tag.type = 'text';
            self.settings.removeUnique('text');
          }

          return true;
        },
        tagRemoved: function($tag) {
          self.standard.buildQuery();
          if ($scope.onRemove) {
            $scope.onRemove({item: $tag});
          }
        },
        removeTags: function() {
          self.standard.queries = [];
          self.standard.activeQuery = {};
          self.standard.buildQuery();
          if ($scope.onAllRemoved) {
            $scope.onAllRemoved();
          }
        },
        buildQuery: function() {
          self.standard.activeQuery = {};

          var queryType = self.settings.typeMap();

          self.standard.queries.forEach(function(item) {
            // ** TODO ** Handle text types
            if (!item.type || item.type === 'text') {
              self.standard.activeQuery.text = item.name;
              return;
            }

            if (item.type === 'role') {
              self.standard.activeQuery.role = item.value;
              return;
            }

            if (item.type === 'hired') {
              self.standard.activeQuery.hired = '$gte,' + self.options.dateAgo(item.text);
              return;
            }

            if (item.type === 'created') {
              self.standard.activeQuery.createdAt = '$gte,' + self.options.dateAgo(item.text);
              return;
            }

            if (item.type === 'active') {
              self.standard.activeQuery.last_login = '$gte,' + self.options.dateAgo(item.text);
              return;
            }

            if (item.type === 'activeStatus') {
              self.standard.activeQuery.suspended = item.value;
              return;
            }

            queryType[item.type].push(item._id);
          });

          for (var key in queryType) {
            if (queryType[key].length) {
              self.standard.activeQuery[key + 's'] = queryType[key];
            }
          }
          self.buildAndCombineQueries();
        }
      };

      self.groupMatch = {
        queries: [],
        activeQuery: {},
        getOptions: function(input) {
          var deferred = $q.defer();

          var options = [];

          var queries = [
            self.users.get(input),
            self.categories.get(input)
          ];

          $q.all(queries)
          .then(function(results) {
            var users = results[0];
            var categories = results[1];

            if (users && users.length) {
              options = options.concat(self.users.parse(users));
            }
            if (categories && categories.length) {
              options = options.concat(self.categories.parse(categories));
            }

            deferred.resolve(options);
          }).catch(function(error) {
            console.log('Error in getStandardOptions: ', error);
            deferred.reject();
          });

          return deferred.promise;
        },
        tagAdded: function($tag) {
          self.groupMatch.buildQuery();
          if ($scope.onAdd) {
            $scope.onAdd({item: $tag});
          }
        },
        tagAdding: function($tag) {
          return true;
        },
        tagRemoved: function($tag) {
          self.groupMatch.buildQuery();
          if ($scope.onRemove) {
            $scope.onRemove({item: $tag});
          }
        },
        removeTags: function() {
          self.groupMatch.queries = [];
          self.groupMatch.activeQuery = {};
          self.groupMatch.buildQuery();
          if ($scope.onAllRemoved) {
            $scope.onAllRemoved();
          }
        },
        buildQuery: function() {
          self.groupMatch.activeQuery = {};
          var queryType = self.settings.typeMap();

          self.groupMatch.queries.forEach(function(item) {
            if (!item.type || item.type === 'role' || item.type === 'hired' || item.type === 'created' || item.type === 'active') {
              return;
            }

            queryType[item.type].push(item._id);
          });

          for (var key in queryType) {
            if (queryType[key].length) {
              self.groupMatch.activeQuery[key + 's'] = queryType[key];
            }
          }

          self.buildAndCombineQueries();
        }
      };

      self.buildAndCombineQueries = function() {
        var query = Object.assign({}, self.standard.activeQuery)

        if (self.groupMatch.queries && self.groupMatch.queries.length) {
          query = Object.assign(query, {match_groups: self.groupMatch.activeQuery});
        }
        // Teams match  - teams_match - /|all|one|/
        // Groups match - group_match - /|all|one|/
        // Direct user vs Groups - user_groups - /|and|or|/
        if (self.options.querySpecs.user_groups) {
          query.user_groups = 'and';
        }
        if (self.options.querySpecs.teams_match) {
          if (query.teams && query.teams.length > 1) {
            query.teams_match = 'all';
          }
        }
        if (self.options.querySpecs.group_match) {
          query.group_match = 'all';
        }
        $scope.onQuery({query: query});
      };

      $translate([
        'edit.assessment.active_today',
        'global.contentTypes.users',
        'overview.settings.tabs_locations',
        'overview.settings.tabs_departments',
        'overview.settings.tabs_teams',
        'overview.settings.tabs_org_levels',
        'overview.settings.tabs_grades',
        'overview.settings.tabs_skills',
        'edit.assessment.hired_within',
        'edit.assessment.created_less',
        'edit.assessment.active_today',
        'edit.assessment.active_within',
        'edit.assessment.days',
        'edit.assessment.days_ago'
      ]).then(function(translations) {
        self.translations = translations;
        self.settings.placeholders.users = {name: self.translations['global.contentTypes.users'], text: self.translations['global.contentTypes.users'], _id: 'users', placeholder: true};
        self.settings.placeholders.locations = {name: self.translations['overview.settings.tabs_locations'], text: self.translations['overview.settings.tabs_locations'], _id: 'locations', placeholder: true};
        self.settings.placeholders.settings = {name: self.translations['overview.settings.tabs_departments'], text: self.translations['overview.settings.tabs_departments'], _id: 'departments', placeholder: true};
        self.settings.placeholders.teams = {name: self.translations['overview.settings.tabs_teams'], text: self.translations['overview.settings.tabs_teams'], _id: 'teams', placeholder: true};
        self.settings.placeholders.org_levels = {name: self.translations['overview.settings.tabs_org_levels'], text: self.translations['overview.settings.tabs_org_levels'], _id: 'org_levels', placeholder: true};
        self.settings.placeholders.grades = {name: self.translations['overview.settings.tabs_grades'], text: self.translations['overview.settings.tabs_grades'], _id: 'grades', placeholder: true};
        self.settings.placeholders.skills = {name: self.translations['overview.settings.tabs_skills'], text: self.translations['overview.settings.tabs_skills'], _id: 'skill', placeholder: true};
      });

    }],
    controllerAs: 'userGroupSearch'
  };
}]);
